import React from 'react';
import Icon from '../../../components/AppIcon';

const CostSavingsCalculator = ({ employeeCount, costSavings }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-PG', {
      style: 'currency',
      currency: 'PGK',
      minimumFractionDigits: 2
    })?.format(amount || 0);
  };

  // Calculate breakdown
  const manualCostPerEmployee = 50; // K50 per employee per month
  const annualManualCost = employeeCount * manualCostPerEmployee * 12;
  const subscriptionCost = annualManualCost - costSavings;
  
  const savingsBreakdown = [
    {
      label: 'Reduced Administrative Overhead',
      amount: costSavings * 0.4,
      percentage: 40,
      color: 'blue'
    },
    {
      label: 'Compliance Penalty Avoidance',
      amount: costSavings * 0.35,
      percentage: 35,
      color: 'green'
    },
    {
      label: 'Operational Efficiency',
      amount: costSavings * 0.25,
      percentage: 25,
      color: 'purple'
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900">Cost Savings Calculator</h2>
        <p className="text-sm text-gray-600 mt-1">Automated vs manual processing</p>
      </div>
      {/* Comparison */}
      <div className="space-y-4 mb-6">
        <div className="bg-red-50 border border-red-200 rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm font-medium text-red-900">Manual Processing</span>
            <Icon name="AlertCircle" className="w-4 h-4 text-red-600" />
          </div>
          <p className="text-2xl font-bold text-red-900">{formatCurrency(annualManualCost)}</p>
          <p className="text-xs text-red-700 mt-1">Annual cost estimate</p>
        </div>

        <div className="bg-green-50 border border-green-200 rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm font-medium text-green-900">Automated System</span>
            <Icon name="CheckCircle" className="w-4 h-4 text-green-600" />
          </div>
          <p className="text-2xl font-bold text-green-900">{formatCurrency(subscriptionCost)}</p>
          <p className="text-xs text-green-700 mt-1">Annual subscription cost</p>
        </div>
      </div>
      {/* Total Savings */}
      <div className="bg-gradient-to-r from-blue-50 to-purple-50 border border-blue-200 rounded-lg p-4 mb-6">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-medium text-gray-900">Total Annual Savings</span>
          <Icon name="TrendingUp" className="w-4 h-4 text-blue-600" />
        </div>
        <p className="text-3xl font-bold text-blue-900">{formatCurrency(costSavings)}</p>
      </div>
      {/* Savings Breakdown */}
      <div>
        <h3 className="text-sm font-semibold text-gray-900 mb-3">Savings Breakdown</h3>
        <div className="space-y-3">
          {savingsBreakdown?.map((item, index) => (
            <div key={index}>
              <div className="flex items-center justify-between mb-1">
                <span className="text-xs text-gray-600">{item?.label}</span>
                <span className="text-xs font-medium text-gray-900">{formatCurrency(item?.amount)}</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div
                  className={`bg-${item?.color}-600 h-2 rounded-full`}
                  style={{ width: `${item?.percentage}%` }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CostSavingsCalculator;